// A campaign carousel's picked products as the description editor shows them: one entry per product, in the chip
// picker's order, each with the description the merchant typed. Picking or removing chips re-syncs the list and keeps
// the text already typed for products still picked.
export class ProductCarouselEditor {
  products = $state([])

  // products: the saved picks as CampaignsHelper#campaign_carousel_products builds them ({ id, name, image_url,
  // description }).
  constructor({ products = [] } = {}) {
    this.products = products.map(product => ({ ...product, description: product.description ?? '' }))
  }

  // picks: the chip picker's products in order ({ id, name, image_url }).
  sync(picks) {
    const current = new Map(this.products.map(product => [String(product.id), product]))
    this.products = picks.map(pick => {
      const existing = current.get(String(pick.id))
      return {
        id: pick.id,
        name: pick.name,
        image_url: pick.image_url ?? existing?.image_url ?? null,
        description: existing?.description ?? '',
      }
    })
  }
}
